







export const getPlaceholderProps = ({
  asset,
  assetError,
  transcodeFailed
}) => {
  if (!asset) {
    return {
      icon: 'corrupt',
      text: 'This video has been removed.',
      subtitle:
      "Get in touch with the owner if this isn't what you're expecting."
    };
  }

  if (transcodeFailed) {
    return {
      icon: 'unsupported',
      text: 'This file type is not supported by the video player.',
      subtitle:
      'It may be possible to download the video and open with another application.'
    };
  }

  return {
    icon: assetError ? 'fetcherror' : 'faq',
    text: assetError ?
    'There was a problem retrieving this video.' :
    'This video seems to be missing.',
    subtitle: assetError ?
    'Try refreshing the page.' :
    "Get in touch with the owner if this isn't what you're expecting."
  };
};